import { Metamodel } from '../base/model';
import { IModel, IAttribute } from '../base/annotation';
import { LinkedService } from '../linkedservice/linkedservice';

import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { AuthenticationType, IKeyValuePair, IViolation, shellStringResources, Credential, azureCloudTypeDef } from 'shell-models-lib';
import { GlobalVariables } from 'app/services/globals';

@Metamodel.model({
    name: adfModelTypeMap.odata.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.OData_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.OData_DisplayText)
    ]
})
export class ODataLinkedService extends LinkedService {

    public static readonly MODEL: IModel;
    public static readonly URL: IAttribute;
    public static readonly USER_NAME: IAttribute;
    public static readonly PASSOWRD: IAttribute;
    public static readonly SERVICE_PRINCIPAL_ID: IAttribute;
    public static readonly SERVICE_PRINCIPAL_KEY: IAttribute;
    public static readonly SERVICE_PRINCIPAL_EMBEDDED_CERT: IAttribute;
    public static readonly SERVICE_PRINCIPAL_EMBEDDED_CERT_PASSWORD: IAttribute;
    public static readonly TENANT: IAttribute;
    public static readonly AAD_RESOURCE_ID: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServiceUrl,
        association: 'URL',
        templatable: true
    })
    public url?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_AuthenticationType
    })
    public authenticationType?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_UserName,
        association: 'USER_NAME',
        templatable: true
    })
    public userName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Password,
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        association: 'PASSOWRD',
        templatable: true,
        accepts: ['String']
    })
    public password?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_AzureCloudType
    })
    public azureCloudType: azureCloudTypeDef;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServicePrincipalID,
        association: 'SERVICE_PRINCIPAL_ID',
        templatable: true
    })
    public servicePrincipalId: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServicePrincipalKey,
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        association: 'SERVICE_PRINCIPAL_KEY',
        templatable: true,
        accepts: ['String']

    })
    public servicePrincipalKey?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServicePrincipalEmbeddedCert,
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        association: 'SERVICE_PRINCIPAL_EMBEDDED_CERT',
        templatable: true,
        accepts: ['String']
    })
    public servicePrincipalEmbeddedCert?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_ServicePrincipalEmbeddedCertPassword,
        constraint: {
            validator: validateAKVLinkedserviceReference
        },
        association: 'SERVICE_PRINCIPAL_EMBEDDED_CERT_PASSWORD',
        templatable: true,
        accepts: ['String']
    })
    public servicePrincipalEmbeddedCertPassword?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: stringResources.ModelName_Tenant,
        association: 'TENANT',
        templatable: true
    })
    public tenant: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_AADResourceId,
        association: 'AAD_RESOURCE_ID',
        templatable: true
    })
    public aadResourceId: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_AuthHeaders
    })
    public authHeaders?: Array<IKeyValuePair<string, string | null>> = [];

    @Metamodel.attribute({
        display: shellStringResources.Credential,
        reference: true,
        constraint: {
            validator: ODataLinkedService.validateCredential
        }
    })
    public credential?: Credential;

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    private static validateCredential(linkedService: ODataLinkedService, referencedCredential: Credential): IViolation[] | undefined {
        if (GlobalVariables.enableConnectorUserAuthCred && linkedService?.authenticationType === AuthenticationType.UserAuth && !referencedCredential) {
            return [{
                context: linkedService,
                message: () => shellStringResources.Error_InvalidCredentialReferenced
            }];
        }
        return undefined;
    }
}
